import store from '../store.es6'

const ApiService = {

  async findAllPaginated (model, filter, sort, pagination) {
    const params = {}

    if (filter) {
      Object.assign(params, filter)
    }

    if (sort && sort.column) {
      // check format 'table.column'
      const column = !/^.+\..+$/.test(sort.column) ? `${model}.${sort.column}` : sort.column
      Object.assign(params, {
        sort: `${column}+${sort.desc ? 'DESC' : 'ASC'}`
      })
    }

    if (pagination) {
      Object.assign(params, {
        limit: pagination.limit,
        offset: pagination.limit * (pagination.page - 1),
      })
    }

    return await store.dispatch('lazyItems/getItems', { model, params })
  },

  async findAll (model, filter, sort) {
    const result = await this.findAllPaginated(model, filter, sort)

    return result.items
  }
}

export default ApiService
